export default __webpack_public_path__ + "wellevate-log-print.bf8d581ace0ab554f20e.png";